import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/license")({
  beforeLoad: () => {
    throw redirect({ to: "/terms", hash: "open-source" });
  },
});
